import Component from "./KeyboardShortcuts";
export default Component;
